
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/supported-blocks",
      function () {
        return require("private-next-pages/supported-blocks.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/supported-blocks"])
      });
    }
  